import { useEffect, useRef } from 'react';

/**
 * React hook to get previous value of object.
 *
 * Example usage:
 *
 * const previousState = usePrevious(someObject);
 *
 * useEffect(() => {
 *  if (!isEqual(previousState, someObject)) {
 *      doSomething();
 *  }
 * }, [someObject]);
 *
 * @param value object to get previous value
 * @returns previous value of object, by default undefined.
 */
export const usePrevious = function (value: any): any {
  const ref = useRef(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
